import React, { useState } from "react";
import "./GameContent.css";
import gridData from "../../../gameDataArrays";
import SelectCategory from "../GameContent/SelectCategory/SelectCategory";
import WaitingForSelect from "../GameContent/WaitingForSelect/WaitingForSelect";
import ChameleonVote from "../GameContent/ChameleonVote/ChameleonVote";
import VoteResults from "../GameContent/VoteResults/VoteResults";
import tickIcon from "../../../icons/tickIcon.png";

const GameContent = ({
  users,
  name,
  updateBoard,
  boardSelectionNum,
  updateRoundParams,
  roundParams,
  roundStarted,
  updateRoundStarted,
  updateVoteData,
  voteCountData,
  currentVotingData,
  resetRoundData,
  chameleonGuess,
  setChameleonGuess,
  showResults,
  setShowResults,
  sendGuessedWord,
  guessedWord,
  currentScores,
  roundScore,
  calcScores,
  updatePromptData,
  currentPromptData,
}) => {
  let numOfPlayers = users.length;
  let localPlayer = {};

  let totalVotes = Object.keys(voteCountData).reduce(
    (sum, key) => sum + parseFloat(voteCountData[key] || 0),
    0
  );

  const [selectedWord, selectWord] = useState("");
  const [localInputTracker, setLocalInput] = useState("");

  // sets the localPlayer
  if (users) {
    users.forEach((user) => {
      if (user.name === name.toLowerCase()) return (localPlayer = user);
    });
  }

  const beginRound = () => {
    resetRoundData();
    selectWord("");
    setLocalInput("");
    let newPlayerTurn = null;

    if (roundParams.playerTurn === numOfPlayers - 1) {
      newPlayerTurn = 0;
    } else newPlayerTurn = roundParams.playerTurn + 1;

    let randomChameleon = Math.floor(Math.random() * (numOfPlayers - 0) + 0);

    let randomChosenWord = Math.floor(Math.random() * (15 - 0) + 0);

    updateRoundStarted(roundStarted);

    updateRoundParams({
      noOfTurnsTaken: 0,
      playerTurn: newPlayerTurn,
      chameleonID: randomChameleon,
      secretWordID: randomChosenWord,
    });
  };

  const endPlayerTurn = (roundParams) => {
    let newPlayerTurn = null;

    if (roundParams.playerTurn === numOfPlayers - 1) {
      newPlayerTurn = 0;
    } else newPlayerTurn = roundParams.playerTurn + 1;

    updateRoundParams({
      noOfTurnsTaken: roundParams.noOfTurnsTaken + 1,
      playerTurn: newPlayerTurn,
      chameleonID: roundParams.chameleonID,
      secretWordID: roundParams.secretWordID,
    });
  };

  const showSelection = (selectionId) => {
    if (selectionId !== "none") {
      updateBoard(selectionId);
    }
  };

  const selectWordGuess = (word) => {
    if (
      totalVotes === numOfPlayers &&
      roundStarted === true &&
      chameleonGuess === true &&
      users[roundParams.chameleonID]?.name === localPlayer?.name
    ) {
      selectWord(word);
    }
  };

  const submitGuessedWord = (selectedWord) => {
    sendGuessedWord(
      selectedWord ===
        gridData?.gameData[boardSelectionNum]?.prompt[
          roundParams?.secretWordID
        ],
      selectedWord
    );

    calcScores(
      currentVotingData,
      selectedWord ===
        gridData?.gameData[boardSelectionNum]?.prompt[roundParams?.secretWordID]
    );
  };

  let listItems = gridData?.gameData[boardSelectionNum]?.prompt.map(
    (word, index) => (
      <p
        className={
          users[roundParams.chameleonID]?.name !== localPlayer.name
            ? "wordBox"
            : "wordBoxChameleon"
        }
        key={index}
        onClick={() => selectWordGuess(word)}
        style={
          roundStarted === true &&
          index === roundParams.secretWordID &&
          users[roundParams.chameleonID]?.name !== localPlayer.name
            ? { backgroundColor: "#69F0AE" }
            : { backgroundColor: "white" }
        }
      >
        {word}
      </p>
    )
  );

  return (
    <div className="gameBoardContainer">
      {roundStarted === false ? (
        <div>
          {users[roundParams.playerTurn].name === localPlayer.name ? (
            <SelectCategory
              showSelection={showSelection}
              beginRound={beginRound}
            ></SelectCategory>
          ) : (
            <WaitingForSelect
              playerName={users[roundParams.playerTurn].name}
            ></WaitingForSelect>
          )}
        </div>
      ) : null}

      {roundParams.noOfTurnsTaken === numOfPlayers &&
      totalVotes !== numOfPlayers ? (
        <ChameleonVote
          users={users}
          localPlayer={localPlayer}
          updateVoteData={updateVoteData}
          currentVotingData={currentVotingData}
        ></ChameleonVote>
      ) : null}

      {totalVotes === numOfPlayers &&
      roundStarted === true &&
      roundParams.chameleonID !== null ? (
        <VoteResults
          users={users}
          localPlayer={localPlayer}
          voteCountData={voteCountData}
          chameleonIndex={roundParams?.chameleonID}
          roundStarted={roundStarted}
          updateRoundStarted={updateRoundStarted}
          chameleonGuess={chameleonGuess}
          setChameleonGuess={setChameleonGuess}
          showResults={showResults}
          setShowResults={setShowResults}
          secretWord={
            gridData?.gameData[boardSelectionNum]?.prompt[
              roundParams?.secretWordID
            ]
          }
          guessedWord={guessedWord}
          currentScores={currentScores}
          roundScore={roundScore}
          currentVotingData={currentVotingData}
        ></VoteResults>
      ) : null}

      {roundStarted === true && roundParams.noOfTurnsTaken !== numOfPlayers ? (
        <div>
          {users[roundParams.playerTurn].name === localPlayer.name ? (
            <div className="playerRoundInstructionsContainer">
              <p>
                Its your turn. Submit your secret word clue and click below to
                end your turn:
              </p>

              <input
                placeholder="Enter secret word prompt"
                className="wordGuessInput"
                type="text"
                onChange={(event) => setLocalInput(event.target.value)}
                onKeyUp={(event) => {
                  if (
                    event.keyCode === 13 &&
                    event.target.value.trim().length > 0
                  ) {
                    updatePromptData(event.target.value, localPlayer.name);
                    endPlayerTurn(roundParams);
                  }
                }}
                autoComplete="off"
                maxLength="40"
              />
              <div
                className="endTurnButton"
                onClick={() => {
                  if (localInputTracker.trim().length > 0) {
                    updatePromptData(localInputTracker, localPlayer.name);
                    endPlayerTurn(roundParams);
                  }
                }}
              >
                Submit word
                <img className="tickIcon" src={tickIcon} alt="end your turn" />
              </div>
            </div>
          ) : (
            <div className="playerRoundInstructionsContainer">
              <p>
                Its {users[roundParams.playerTurn].name}'s turn to say their
                secret word prompt.
              </p>
            </div>
          )}
        </div>
      ) : null}

      {showResults !== true || roundStarted === false ? (
        <p className="categoryTitle">
          Category: {gridData?.gameData[boardSelectionNum]?.category}
        </p>
      ) : null}

      {showResults !== true || roundStarted === false ? (
        <div className="wordListContainer">{listItems}</div>
      ) : null}

      {totalVotes === numOfPlayers &&
      roundStarted === true &&
      chameleonGuess === true &&
      users[roundParams.chameleonID]?.name === localPlayer?.name &&
      selectedWord.length > 0 &&
      showResults !== true ? (
        <div className="submitGuessContainer">
          <div
            className="submitGuessButton"
            onClick={() => submitGuessedWord(selectedWord)}
          >
            <p className="submitGuessText">Submit {selectedWord}?</p>
            <img
              className="tickIcon"
              src={tickIcon}
              alt="confirm the category selection"
            />
          </div>
        </div>
      ) : null}

      {roundStarted === true && roundParams.noOfTurnsTaken !== numOfPlayers ? (
        <div className="playerRoleInfoContainer">
          {users[roundParams.chameleonID]?.name === localPlayer.name ? (
            <p>
              You are the chameleon, you don't know the secret word. Try to
              blend in!
            </p>
          ) : (
            <p>You are NOT the chameleon.</p>
          )}
        </div>
      ) : null}

      {roundStarted === true && totalVotes !== numOfPlayers ? (
        <div className="playerSubmittedWordContainer">
          <div className="playerSubmittedWordTitle">Submitted Prompts</div>

          {users.map((user) => (
            <div key={user.name} className="wordSubmissionsContainer">
              <div className="wordSubmitPlayerName">
                <p
                  className="wordSubmitPlayerNameText"
                  style={
                    user.name === localPlayer?.name
                      ? { color: "yellow" }
                      : { color: "" }
                  }
                >
                  {user.name}
                </p>
              </div>
              <div className="submittedWordContainer">
                {currentPromptData?.[user?.name] !== undefined ? (
                  <p>{currentPromptData[user.name]}</p>
                ) : (
                  "-"
                )}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default GameContent;
